(() => {
  const textMap = new Map([
    ['添加到购物车', 'カートに追加'],
    ['加入购物车', 'カートに追加'],
    ['选择选项', 'オプションを選ぶ'],
    ['售罄', '売り切れ']
  ]);

  const replaceExactTextNodes = (root) => {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const raw = node.nodeValue || '';
      const trimmed = raw.trim();
      const replacement = textMap.get(trimmed);
      if (!replacement) return;
      node.nodeValue = raw.replace(trimmed, replacement);
    });
  };

  const refineUi = () => {
    document.querySelectorAll('.quick-add__submit').forEach(replaceExactTextNodes);

    document.querySelectorAll('.footer input[id^="NewsletterForm--"]').forEach((input) => {
      input.setAttribute('placeholder', 'メールアドレス');
    });
    document.querySelectorAll('.footer label[for^="NewsletterForm--"]').forEach((label) => {
      label.textContent = 'メールアドレス';
    });
    document.querySelectorAll('.footer .newsletter-form__button').forEach((button) => {
      button.setAttribute('aria-label', '登録');
    });

    document
      .querySelectorAll('.shopify-section[id*="featured_collection1"] .card__heading .full-unstyled-link')
      .forEach((link) => {
        const current = link.textContent.trim();
        const refined = current.replace(/^HandyMite\s+/i, '');
        if (refined !== current) link.textContent = refined;
      });
  };

  const start = () => {
    refineUi();
    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        refineUi();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
